<script setup lang="ts">
import { LucideLandmark } from 'lucide-vue-next'
import { CurrencyIcon } from '~/components/ui/currency-icon'

const props = withDefaults(defineProps<{ currencies?: string[] }>(), {
  currencies: () => ['usd', 'eur', 'rub', 'kzt']
})

const { t } = useI18n()

const linksText = {
  usd: t('widget.rates.links.usd'),
  eur: t('widget.rates.links.eur'),
  rub: t('widget.rates.links.rub'),
  kzt: t('widget.rates.links.kzt')
}
</script>

<template>
  <div class="flex flex-col gap-2 md:-m-6 md:flex-row md:items-stretch md:gap-0">
    <template v-for="item in props.currencies" :key="item">
      <NuxtLinkLocale
        class="flex flex-1 items-center justify-center gap-2 rounded-lg px-3 py-2 text-blue-600 transition-colors hover:bg-blue-50 md:rounded-none md:px-4 md:py-6 md:first:rounded-l-lg"
        :to="`/rates/${item}`"
      >
        <CurrencyIcon :code="item" size="lg" />
        {{ linksText[item as keyof typeof linksText] }}
      </NuxtLinkLocale>
    </template>

    <NuxtLinkLocale
      to="/rates/nbkr"
      class="flex flex-1 items-center justify-center gap-2 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-green-700 transition-colors hover:bg-green-100 md:rounded-l-none md:rounded-r-lg md:border-0 md:border-l md:py-6"
    >
      <LucideLandmark class="size-5" />
      <span class="font-medium">{{ t('common.nbkr_rates_heading') }}</span>
    </NuxtLinkLocale>
  </div>
</template>
